import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideAuth, getAuth, connectAuthEmulator } from '@angular/fire/auth';
import { provideFirestore, getFirestore, connectFirestoreEmulator } from '@angular/fire/firestore';
import { connectStorageEmulator, getStorage, provideStorage } from '@angular/fire/storage';
import { connectFunctionsEmulator, FunctionsModule, getFunctions, provideFunctions } from '@angular/fire/functions';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import { AUTH_CONFIG_TOKEN, AUTH_PROVIDER_TOKEN, AuthConfig } from 'libs/auth/auth.config';
import { FirebaseAuthProvider } from 'libs/auth/providers/firebase-auth.provider';

export const AUTH_CONFIG: AuthConfig = {
  baseUrl: environment.url,
  bundleId: environment.bundleId,
};

// Emulateurs locaux : valeurs par defaut alignees sur firebase.json, surchargeables
// depuis environment.ts (`emulators: { host, auth, firestore, storage, functions }`).
// Le spread tolere un environment.ts qui ne declare pas la cle.
const EMULATORS = {
  host: '127.0.0.1',
  auth: 9099,
  firestore: 8080,
  storage: 9199,
  functions: 5002,
  ...((environment as { emulators?: Record<string, string | number> }).emulators ?? {}),
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    FunctionsModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => {
      const auth = getAuth();
      if (environment.useEmulators) {
        connectAuthEmulator(auth, `http://${EMULATORS.host}:${EMULATORS.auth}`, { disableWarnings: true });
      }
      return auth;
    }),
    provideFirestore(() => {
      const firestore = getFirestore();
      if (environment.useEmulators) {
        connectFirestoreEmulator(firestore, EMULATORS.host as string, EMULATORS.firestore as number);
      }
      return firestore;
    }),
    provideStorage(() => {
      const storage = getStorage();
      if (environment.useEmulators) {
        connectStorageEmulator(storage, EMULATORS.host as string, EMULATORS.storage as number);
      }
      return storage;
    }),
    provideFunctions(() => {
      const functions = getFunctions();
      if (environment.useEmulators) {
        connectFunctionsEmulator(functions, EMULATORS.host as string, EMULATORS.functions as number);
      }
      return functions;
    }),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: AUTH_CONFIG_TOKEN, useValue: AUTH_CONFIG },
    { provide: AUTH_PROVIDER_TOKEN, useClass: FirebaseAuthProvider },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
